import { render, staticRenderFns } from "./TicketCollection.vue?vue&type=template&id=6f4435ff&scoped=true&"
import script from "./TicketCollection.vue?vue&type=script&lang=js&"
export * from "./TicketCollection.vue?vue&type=script&lang=js&"
import style0 from "./TicketCollection.vue?vue&type=style&index=0&id=6f4435ff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4435ff",
  null
  
)

export default component.exports